export default __webpack_public_path__ + "static/media/japan.ccbe3ff8.svg";